import React, { useEffect, useState } from "react";
import StripedGrid from "../../Components/StripeDataGrid";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
} from "@mui/material";
import ModalDetails from "../../Components/Catalogo/ModalDetails";
import { validateToken } from "../../Apis/validateToken";
import { useAuth } from "../../Context/Auth_v2/Auth.context";
import { getAllProducts } from "../../Apis/getAllProducts";
import CustomTextField from "../../Components/CustomTextField";
import {
  ArrowBack,
  ArrowBackIos,
  ArrowBackIosNew,
  ArrowDropDown,
  ArrowForward,
  ArrowLeft,
  Search,
} from "@mui/icons-material";

const ViewCatalog = () => {
  const { token, user, dataUserAccess } = useAuth();
  const [openModal, setOpenModal] = useState(false);
  const [study, setStudy] = useState({});
  const [infoFranquicia, setInfoFranquicia] = useState({});
  const [resultados, setResultados] = useState([]);
  // ======================================================================

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [rangeInput, setRangeInput] = useState("");

  // const handleRangeSubmit = () => {
  //   const match = rangeInput.match(/(\d+)\s*al\s*(\d+)/i);
  //   if (!match) return alert("Formato inválido. Usa '15 al 25'");
  //   const start = parseInt(match[1]);
  //   const end = parseInt(match[2]);
  //   if (start >= end || start < 1) return alert("Rango inválido");

  //   const newPageSize = end - start + 1;
  //   const newPage = Math.floor((start - 1) / newPageSize);

  //   setPaginationModel({
  //     page: newPage,
  //     pageSize: newPageSize,
  //   });
  // };
  const [filteredRows, setFilteredRows] = useState([]);
  const handleRangeSubmit = () => {
    const match = rangeInput.match(/(\d+)\s*al\s*(\d+)/i);
    if (!match) return alert("Formato inválido. Usa '15 al 25'");

    const start = parseInt(match[1]);
    const end = parseInt(match[2]);
    if (start >= end || start < 1) return alert("Rango inválido");

    const filtered = resultados.filter(
      (item) => item.folioID >= start && item.folioID <= end
    );

    setFilteredRows(filtered);

    setPaginationModel({
      page: 0,
      pageSize: Math.min(filtered.length, 10), // Máximo 10 por página o los que haya
    });
  };

  // ========================================================================
  const excludedColumns = ["icono"];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { branch, store } = await validateToken(token, user.uid);
        if (branch && store) {
          const products = await getAllProducts(branch, store);
          const sortedProducts = products
            .slice()
            .sort((a, b) =>
              a.name.localeCompare(b.name, "es", { sensitivity: "base" })
            )
            .map((item, index) => ({
              ...item,
              folioID: index + 1, // Asignar folio consecutivo empezando desde 1
            }));
          console.log("Products", products);
          setResultados(sortedProducts);
          setFilteredRows(sortedProducts);
          setInfoFranquicia({ branch, store });
        }
      } catch (error) {
        console.error("Error fetching Data", error);
      }
    };
    fetchData();
  }, [token, user, dataUserAccess]);

  const columns = [
    { field: "folioID", headerName: "ID", width: 90 },
    {
      field: "code",
      headerName: "Clave",
      width: 150,
      renderHeader: () => <p style={design.headerTable}>Clave</p>,
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Nombre",
      width: 250,
      renderHeader: () => <p style={design.headerTable}>Nombre</p>,
      headerAlign: "center",
    },
    {
      field: "price",
      headerName: "Precio",
      width: 130,
      headerAlign: "center",
      renderHeader: () => <p style={design.headerTable}>Precio</p>,
      valueFormatter: ({ row }) => {
        const { price } = row;
        if (price) {
          return price.toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
            currencyDisplay: "symbol",
          });
        }
        return 0;
      },
      renderCell: ({ row }) => {
        return (
          <p>
            {row.price.toLocaleString("es-MX", {
              style: "currency",
              currency: "MXN",
              currencyDisplay: "symbol",
            }) || 0}
          </p>
        );
      },
    },
    {
      field: "available",
      headerName: "Disponible",
      width: 190,
      headerAlign: "center",
      renderHeader: () => <p style={design.headerTable}>Disponible</p>,
      renderCell: ({ row }) => {
        return <p>{row.available ? "Disponible" : "No disponible"}</p>;
      },
    },
  ];

  return (
    <>
      <h1 style={design.title}>Catálogo de servicios</h1>
      <Grid container justifyContent="center">
        <CustomTextField
          id="Rango (ej. 15 al 25)"
          label="Rango (ej. 15 al 25)"
          grid={3}
          gridXs={3}
          required={false}
          variant="outlined"
          value={rangeInput}
          sx={{ height: 55 }}
          onChange={(e) => setRangeInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // evita comportamiento por defecto como submit de formulario
              handleRangeSubmit();
            }
          }}
          InputProps={{
            sx: { height: 55 },
            startAdornment: <InputAdornment position="start" />,
            endAdornment: (
              <InputAdornment position="start">
                <IconButton name="Buscar Rango" onClick={handleRangeSubmit}>
                  <ArrowForward />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <StripedGrid
        loading={false}
        columns={columns}
        rows={filteredRows}
        onRowClick={(row) => {
          setOpenModal(true);
          setStudy(row.row);
        }}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        setPageSize={(size) =>
          setPaginationModel((prev) => ({ ...prev, pageSize: size }))
        }
        getRow={(params) => params.folioID}
        pageSize={paginationModel.pageSize}
        color="#fff"
        name={"Catalogo_de_Estudios"}
        exportPermission={true}
        excludedColumns={excludedColumns}
        evenBackgroundColor="#65B32E40"
        oddBackgroundColor="#efb2b2"
        oddOpacity={0.7}
        bgColorHeader="#2e6266"
        w="93%"
      />
      {/* </Stack> */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <ModalDetails
            study={study}
            setOpenModal={setOpenModal}
            dataUserAccess={dataUserAccess}
            infoFranquicia={infoFranquicia}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewCatalog;

/**
 * design es un objeto que contiene estilos personalizados.
 * @type {Object}
 */
const design = {
  title: {
    fontFamily: "Lexend",
    color: "#093046",
    fontWeight: 500,
    lineHeight: "56px",
    letterSpacing: "0em",
    textAlign: "center",
  },
  headerTable: {
    fontSize: 16,
    color: "#00518c",
    fontFamily: "Lexend",
    justifyContent: "center",
  },
};
